<template>
    <BreadCrumb PageTitle="Liste des comptes prépayés" />
    <ListePrepaidAccount/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListePrepaidAccount from "@/components/Compte/ListePrepaidAccount.vue";
  
    export default defineComponent({
      name: "ListePrepaidAccountPage",
      components: {
        BreadCrumb,
        ListePrepaidAccount,
      },
    });
  </script>